import { render } from "./SupplierHeadList.vue?vue&type=template&id=5a179587"
import script from "./SupplierHeadList.vue?vue&type=script&lang=js"
export * from "./SupplierHeadList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__